import React from "react";

export function LoadingPage() {
  return (
    <div style={{ background: "#000000" }}>
      <img
        src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
        width={"100%"}
        alt="로딩이미지"
      />
    </div>
  );
}
